import React, { useEffect, useRef } from "react"
import { WorkItem } from "../../../models/WorkItem/WorkItem"
import Card from "./Card"
import { BarLoader } from "react-spinners"
import colors from "../../../config/color"
import { useIntersection, usePrevious } from "react-use"

type Props = {
  items: WorkItem[] | undefined
  onLoadMore: () => void
  isLoading: boolean
  canLoadMore: boolean
}

export const RankingBody: React.FC<Props> = ({
  items,
  onLoadMore,
  isLoading,
  canLoadMore,
}: Props) => {
  const intersectionRef = useRef<HTMLDivElement | null>(null)
  const intersection = useIntersection(intersectionRef, {})
  const prevIntersection = usePrevious(intersection)

  useEffect(() => {
    if (intersection?.isIntersecting && !prevIntersection?.isIntersecting) {
      onLoadMore()
    }
  }, [
    intersection?.isIntersecting,
    prevIntersection?.isIntersecting,
    canLoadMore,
    onLoadMore,
  ])

  return (
    <>
      <div className="p-ranking-works-list">
        {items &&
          items.map((item, index) => (
            <Card item={item} rank={index + 1} key={item.id} />
          ))}
      </div>
      <div className="p-button -spacer-sm" ref={intersectionRef}>
        {(items === undefined || isLoading) && (
          <div>
            <BarLoader color={colors.spectrum.tieupTheme} />
          </div>
        )}
        {canLoadMore && !isLoading && (
          <>
            <button
              className="c-button-secondary -outline -full"
              onClick={onLoadMore}
            >
              もっと見る
            </button>
          </>
        )}
      </div>
    </>
  )
}
